import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logoutUser } from "../../store/auth/login/actions";

const Logout = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        dispatch(logoutUser(navigate));
    }, [dispatch, navigate]);

    return null; // Instantly redirects without rendering anything
};

export default Logout;
